import React from "react";

import { Spinner } from "@touchtech/web-baselayer-ui";

import css from "./SessionTransitionOverlay.module.css";

const SessionTransitionOverlay: React.FC = () => (
  <div className={css.overlay} role="alert" aria-busy="true">
    <div className={css.spinnerContainer}>
      <Spinner />
    </div>
  </div>
);

export default SessionTransitionOverlay;
